import React from "react";
import Gallery from "./Gallery";
import Fade from "react-reveal/Fade"

export default function ChiSiamo(){

    function checkForRefresh() {
        if (performance.navigation.type === 1) {
            // La pagina è stata ricaricata manualmente, quindi esegui il reindirizzamento
            window.location.href = "https://www.centrozeta.it";
        }
    }
    

    return(
       <div className="container" onload={checkForRefresh()}>
            <div className='riga'>
                <div className="paragrafo" id="gallery_paragrafo">
                    <Fade className="reveal-fade"><p>
                    L'Associazione Centro Zeta viene costituita nel 1990 per volontà di alcune persone che ritenevano importanti i valori dell’altruismo e della solidarietà e che prestavano aiuto in caso di bisogno con i pochi mezzi a disposizione.
                    <br></br><br/>Negli anni il numero di iscritti è aumentato e sono stati potenziati il numero dei mezzi e quello delle attrezzature a disposizione dei volontari.
                    <br></br><br/>L’Associazione opera soprattutto nell’ambito del territorio del X (ex XIII) Municipio del Comune di Roma in caso di micro calamità naturali. Ha prestato la propria opera durante le emergenze anche in ambito nazionale (Sarno, Nocera Umbra, Quindici, L’Aquila, Torrita di Amatrice ecc.) e in quello internazionale partecipando alla Missione Arcobaleno in Albania.
                    </p></Fade>
                </div>
                <div className="image">
                    <Fade className="reveal-fade"><Gallery></Gallery></Fade>
                </div>                             
            </div>
            


       
       
        <div className='riga'>
            <div className="image">
                <Fade className="reveal-fade"><img src="/img/chisiamo2.jpg" id="#home2" alt=""/></Fade>
            </div>
            <div className="paragrafo">
                <Fade className="reveal-fade"><p>
                Durante il periodo invernale organizziamo corsi teorico-pratici rivolti ad alunni e insegnanti delle scuole del ciclo primario e secondario di I grado sui comportamenti da tenere in caso di terremoti o incendi.
                    <br/><br/>Abbiamo vari automezzi antincendio a disposizione ,oltre a motopompe, idrovore, e vari gruppi elettrogeni.
                    <br/><br/>La sede è situata su un terreno di 1.300 mq in Via Giuseppe Beduschi al N° 63 Dragoncello Roma. Logisticamente è organizzata in cinque container adibiti a sala riunione, ufficio, sala riposo, sala comune, sala radio, cucina, bagni, e magazzino.Tutto ciò per essere operativi h24.
                </p></Fade>
            </div>
                                            
        </div>



  </div>
       
    );
}